import { useState } from "react";

export default function Activity() {
  const [videoError, setVideoError] = useState(false);

  const images = [
    "./assets/img1.png",
    "./assets/img2.png",
    "./assets/img3.png",
    "./assets/img4.png",
    "./assets/img5.png",
    "./assets/img6.png",
    "./assets/img7.png",
    "./assets/img8.png",
    "./assets/img9.png",
  ];

  return (
    <div style={s.root}>
      <div style={s.grid} />
      <div style={s.glowTL} />
      <div style={s.glowBR} />

      <div style={s.container}>

        {/* ── Page Header ── */}
        <div style={s.pageHeader}>
          <span style={s.pageHeaderIcon}>📋</span>
          <h1 style={s.pageTitle}>Activity</h1>
        </div>

        {/* ── Scrollable Media List ── */}
        <div style={s.mediaList}>

          {/* Video */}
          <div style={s.mediaCard}>
            {!videoError ? (
            <img
                src="/assets/vid.gif"
                alt="Promo"
                style={s.video}
                onError={() => setVideoError(true)}
            />
            ) : (
            <div style={s.mediaError}>
                <span style={{ fontSize: 32 }}>🎬</span>
                <p style={s.mediaErrorText}>Video unavailable</p>
            </div>
            )}
            <div style={s.mediaLabel}>
              <span style={s.mediaLabelIcon}>▶️</span>
              <span style={s.mediaLabelText}>Promo Video</span>
            </div>
          </div>

          {/* Images */}
          {images.map((src, i) => (
            <ImageCard key={i} src={src} index={i} />
          ))}

        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Space+Mono:wght@400;700&family=Sora:wght@300;400;500;600;700&display=swap');
        @keyframes spin   { to { transform: rotate(360deg); } }
        @keyframes fadeUp { from { opacity:0; transform:translateY(18px); } to { opacity:1; transform:translateY(0); } }
      `}</style>
    </div>
  );
}

// ── Image Card ────────────────────────────────────────────────────────────────
function ImageCard({ src, index }) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError]   = useState(false);

  return (
    <div style={s.mediaCard}>
      {!loaded && !error && (
        <div style={s.imgPlaceholder}>
          <div style={s.imgSpinner} />
        </div>
      )}
      {error ? (
        <div style={s.mediaError}>
          <span style={{ fontSize: 32 }}>🖼️</span>
          <p style={s.mediaErrorText}>Image unavailable</p>
        </div>
      ) : (
        <img
          src={src}
          alt={`Activity ${index + 1}`}
          style={{ ...s.image, ...(loaded ? {} : { display: "none" }) }}
          onLoad={() => setLoaded(true)}
          onError={() => setError(true)}
        />
      )}
      <div style={s.mediaLabel}>
        <span style={s.mediaLabelIcon}>🖼️</span>
        <span style={s.mediaLabelText}>Image {index + 1}</span>
      </div>
    </div>
  );
}

// ── Palette ───────────────────────────────────────────────────────────────────
const C = {
  bg:      "#020c12",
  card:    "rgba(4,16,24,0.90)",
  border:  "rgba(0,229,255,0.10)",
  cyan:    "#00e5ff",
  cyanDim: "rgba(0,229,255,0.4)",
  text:    "#e0f7fa",
  muted:   "rgba(100,180,200,0.5)",
};

// ── Styles ────────────────────────────────────────────────────────────────────
const s = {
  root: {
    minHeight: "100vh", background: C.bg, fontFamily: "'Sora',sans-serif",
    position: "relative", overflow: "hidden", paddingBottom: 100,
  },
  grid: {
    position: "fixed", inset: 0, pointerEvents: "none",
    backgroundImage: "linear-gradient(rgba(0,229,255,0.03) 1px,transparent 1px),linear-gradient(90deg,rgba(0,229,255,0.03) 1px,transparent 1px)",
    backgroundSize: "44px 44px",
  },
  glowTL: {
    position: "fixed", top: -150, left: -100, width: 480, height: 480,
    borderRadius: "50%", pointerEvents: "none",
    background: "radial-gradient(circle,rgba(0,229,255,0.08) 0%,transparent 70%)",
  },
  glowBR: {
    position: "fixed", bottom: -100, right: -80, width: 380, height: 380,
    borderRadius: "50%", pointerEvents: "none",
    background: "radial-gradient(circle,rgba(0,180,200,0.05) 0%,transparent 70%)",
  },
  container: {
    maxWidth: 480, margin: "0 auto", padding: "24px 16px 40px",
    position: "relative", zIndex: 10,
    animation: "fadeUp 0.5s cubic-bezier(0.22,1,0.36,1) both",
  },

  // page header
  pageHeader:     { display: "flex", alignItems: "center", gap: 10, marginBottom: 18 },
  pageHeaderIcon: { fontSize: 22 },
  pageTitle:      { fontSize: 22, fontWeight: 700, color: C.text, letterSpacing: "-0.02em" },

  // media list — vertical scroll
  mediaList: {
    display: "flex", flexDirection: "column", gap: 14,
  },

  // each card
  mediaCard: {
    background: C.card, border: `1px solid ${C.border}`,
    borderRadius: 18, overflow: "hidden",
    backdropFilter: "blur(20px)",
    boxShadow: "0 8px 32px rgba(0,0,0,0.35)",
  },

  // video
  video: {
    width: "100%", display: "block",
    maxHeight: 280, objectFit: "cover",
    background: "#000",
  },

  // image
  image: {
    width: "100%", display: "block",
    objectFit: "cover",
  },

  // loading placeholder
  imgPlaceholder: {
    width: "100%", height: 220,
    display: "flex", alignItems: "center", justifyContent: "center",
    background: "rgba(0,229,255,0.02)",
  },
  imgSpinner: {
    width: 32, height: 32, borderRadius: "50%",
    border: "3px solid rgba(0,229,255,0.12)", borderTopColor: C.cyan,
    animation: "spin 0.75s linear infinite",
  },

  // error state
  mediaError: {
    width: "100%", height: 220,
    display: "flex", flexDirection: "column",
    alignItems: "center", justifyContent: "center", gap: 8,
    background: "rgba(0,229,255,0.02)",
  },
  mediaErrorText: { fontSize: 12, color: C.muted },

  // label bar at bottom of each card
  mediaLabel: {
    display: "flex", alignItems: "center", gap: 8,
    padding: "10px 16px",
    borderTop: `1px solid ${C.border}`,
    background: "rgba(0,229,255,0.015)",
  },
  mediaLabelIcon: { fontSize: 14 },
  mediaLabelText: {
    fontSize: 11, fontWeight: 600, color: C.muted,
    fontFamily: "'Space Mono',monospace", letterSpacing: "0.06em",
  },
};